import { render, staticRenderFns } from "./PageEditorIframe.vue?vue&type=template&id=206b5c68&scoped=true"
import script from "./PageEditorIframe.vue?vue&type=script&lang=js"
export * from "./PageEditorIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206b5c68",
  null
  
)

export default component.exports